import { render, staticRenderFns } from "./LoginOptions.vue?vue&type=template&id=2522615c&"
import script from "./LoginOptions.vue?vue&type=script&lang=js&"
export * from "./LoginOptions.vue?vue&type=script&lang=js&"
import style0 from "./LoginOptions.vue?vue&type=style&index=0&id=2522615c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports